import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService,PlaylistService, ScrollService, ScrollParams } from '../api/';
import * as _ from 'lodash';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {Helper} from '../helper';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'app-my-discoveries',
  templateUrl: './my-discoveries.component.html',
  styleUrls: ['./my-discoveries.component.css']
})
export class MyDiscoveriesComponent implements OnInit, OnDestroy {
  public discoveries: Array<any>;
  private loading = true;
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  private searchTerm: string = '';
  private lastTerm: string = '';
  private viewAsList = true;
  private helper = new Helper();
  callFromDiscoveries: boolean = true;
  private sortedColumn = null;
  private limit :number=10;
  @BlockUI() blockUI: NgBlockUI;
  public onlineOffline: boolean = navigator.onLine;
  enableScrollForDiscovery = true;
  noRecordFound:boolean = false;

  private columnArr = [
    { title: '', key: 'item.image', type: 'image', width: '80px', isSortable: true, responsiveIndex: 'all' },
    { title: 'Artist', key: 'item.artist.name', type: 'anchor', width: '170px', textStyle: ['my-music-artist'], responsiveIndex: 'gt-md' },
    { title: 'Name', key: 'item.name', type: 'anchor', width: '300px', textStyle: ['my-music-name'], responsiveIndex: 'all' },
    { title: 'Date', key: 'created_at', type: 'date', width: '100px', responsiveIndex: 'sm' },
    { title: 'Genres', key: 'item.genre', type: 'anchor', width: '', responsiveIndex: 'sm',isSortable: false, },
    { title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '100px', responsiveIndex: 'sm' }
  ];

  constructor(private playlistService: PlaylistService,private userService: UserService, private scrollService: ScrollService, private router: Router, private route: ActivatedRoute) {
    window.addEventListener('online', () => {
      this.onlineOffline = true;
      this.onlineOffline = false;
    });
    window.addEventListener('offline', () => {this.onlineOffline = false});
    this.discoveries = new Array<any>();
    this.scrollParams.page = 0;
    this.route.queryParams.subscribe((queryParams: any) => {
      if (typeof queryParams.q !== 'undefined') {
        this.searchTerm = queryParams.q;
      }
    });

    // make the changes when the song is removed from the discoveries
    this.playlistService.isMyDiscoveryUpdated.subscribe(res=> {
      if(res != 0) {
        console.log("Observable called " + res);
        this.getDiscoveries();
      }
    });
  }

  ngOnInit() {
    if(screen.width > 767 && screen.width <= 1024 ) {
      this.columnArr = [
        { title: '', key: 'item.image', type: 'image', width: '120px', isSortable: true, responsiveIndex: 'all' },
        { title: 'Artist', key: 'item.artist.name', type: 'anchor', width: '220px', textStyle: ['my-music-artist'], responsiveIndex: 'gt-md' },
        { title: 'Name', key: 'item.name', type: 'anchor', width: '350px', textStyle: ['my-music-name'], responsiveIndex: 'all' },
        { title: 'Date', key: 'created_at', type: 'date', width: '100px', responsiveIndex: 'sm' },
        { title: 'Genres', key: 'item.genre', type: 'anchor', width: '', responsiveIndex: 'gt-md',isSortable: false, },
        { title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '100px', responsiveIndex: 'sm' }
      ];
    }
    if(screen.width < 768) {
      this.columnArr = [
        { title: '', key: 'item.image', type: 'image', width: '70px', isSortable: true, responsiveIndex: 'all' },
        { title: 'Artist', key: 'item.artist.name', type: 'anchor', width: '70px', textStyle: ['my-music-artist'], responsiveIndex: 'gt-md' },
        { title: 'Name', key: 'item.name', type: 'anchor', width: '70px', textStyle: ['my-music-name'], responsiveIndex: 'all' },
        { title: 'Date', key: 'created_at', type: 'date', width: '70px', responsiveIndex: 'sm' },
        { title: 'Genres', key: 'item.genre', type: 'anchor', width: '', responsiveIndex: 'sm',isSortable: false, },
        { title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '70px', responsiveIndex: 'sm' }
      ];
    }
    localStorage.setItem("radio",'0');
    if (localStorage.getItem("viewAsList") == "true") {
      this.viewAsList = true;
    }
    if (localStorage.getItem("viewAsList") == "false") {
      this.viewAsList = false;
    }
    this.scrollService.enableScrollIfDisabled();
    this.getDiscoveries();
    this.scrollService.toggleProgressBar(true);
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getDiscoveries());
  }

  getDiscoveries() {
    let type="discoveries";
    this.loading = true;
    if (this.lastTerm !== this.searchTerm) {
      this.resetScrollParams();
      this.lastTerm = this.searchTerm;
      this.discoveries = new Array<any>();
    }
    this.scrollService.toggleProgressBar(true);
    if (this.localStore(type)) {
      if(this.onlineOffline == false)
        return;
      if(this.enableScrollForDiscovery) {
        this.blockUI.start('Loading, please wait...');
        this.userService.getDiscoveriesRelations(this.scrollParams.page, this.searchTerm, this.sortedColumn, this.limit).subscribe((res) => {
          this.noRecordFound = false;
          this.scrollService.toggleProgressBar(false);
          if (res.length > 0) {
            res.forEach((arrayItem) => {
              arrayItem.item.isSongDownloaded = ((!arrayItem.item.isSongDownloaded) ? 'Streaming' : 'Owned');
              arrayItem.item.discoveredByMe = true;
              this.discoveries.push(arrayItem);
            });
            this.scrollParams.page++;
            this.blockUI.stop();
          }
          if(res.length == 0 || res.length < 20) {
            this.noRecordFound = true;
            this.blockUI.stop();
            this.enableScrollForDiscovery = false;
          } else {
            this.enableScrollForDiscovery = true;
          }
          this.discoveries = _.uniqBy(this.discoveries, 'id');
          this.setLocalStore(type);
          this.loading = false;
        });
      }
    }
    if (!this.onlineOffline) {
      this.blockUI.stop();
      this.loading = false;
    }
    this.loading = false;
  }

  localStore($type) {
    if (this.searchTerm != '') {
      return true;
    }
    if (this.sortedColumn != null) {
      return true;
    }
    let discoveries = JSON.parse(localStorage.getItem($type));
    if (discoveries != null && discoveries.length > 0 ) {
      this.scrollParams.page = Math.ceil(discoveries.length / this.limit);
      this.scrollParams.page++;
      this.playlistService.getCall().toPromise().then((res) => {
        this.discoveries = discoveries;
        this.scrollService.toggleProgressBar(false);
        this.loading = false;
        this.blockUI.stop();
      }).catch((err) => {
        this.discoveries = discoveries;
        this.scrollService.toggleProgressBar(false);
        this.loading = false;
        this.blockUI.stop();
      });
      if(discoveries.length >= 30){
        this.blockUI.stop();
        return true;
      }
      return false;
    } else {
      this.blockUI.stop();
      this.discoveries = [];
      return true;
    }
  }

  setLocalStore($type) {
    if (this.searchTerm == '' && this.sortedColumn == null) {
      this.helper.setLocalStore($type, this.discoveries)
    }
  }

  sortColumn(event) {
    this.enableScrollForDiscovery = true;
    this.loading = true;
    this.scrollService.toggleProgressBar(true);
    this.sortedColumn = event;
    this.scrollParams = new ScrollParams();
    this.discoveries = new Array<any>();
    this.getDiscoveries();
  }

  resetScrollParams() {
    this.scrollParams = new ScrollParams();
  }

  handleSearch(event) {
    this.enableScrollForDiscovery = true;
    this.searchTerm = event.searchTerm;
    let navigationExtras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: { 'q': this.searchTerm },
    };
    this.getDiscoveries();
    this.router.navigate([], navigationExtras);
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  toggleViewAsList(value) {
    this.viewAsList = value;
    if (this.viewAsList == true) {
      localStorage.setItem("viewAsList", "true");
    }
    if (this.viewAsList == false) {
      localStorage.setItem("viewAsList", "false");
    }
  }

  mouseHovering(index) {
    this.discoveries[index].item.isHovering = true;
  }

  mouseLeaving(index) {
    this.discoveries[index].item.isHovering = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/my-discoveries/my-discoveries.component.ts